import React, { useEffect, useState } from 'react';
import { withFormik, Form, Field } from 'formik';
import { setNewPassword, userStatus, removeFromGroup, checkProvisioning, resetPasswordConfirmation, resetUserEmail, appUrls } from '../utils/authService';
import { withTranslation } from 'react-i18next';
import PasswordStrengthMeter from './PasswordStrengthMeter';
import queryString from 'query-string';

const validate = (values, props) => {
  let errors = {};

  if (!values.password) {
    errors.password = props.t('passwordRequired');
  }

  if (values.password.toLowerCase() == values.password) {
    errors.password = props.t('passwordQualify');
  }

  if (values.password.toUpperCase() === values.password) {
    errors.password = props.t('passwordQualify');
  }

  if(!/\d/.test(values.password)) {
    errors.password = props.t('passwordQualify');
  }

  if (values.password.length < 8) {
    errors.password = props.t('passwordQualify');
  }

  if (!/[_()~`!#@$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(values.password)) {
    errors.password = props.t('passwordQualify');
  }

  if (values.password.toLowerCase().includes(props.userProfile.givenName.toLowerCase())) {
    errors.password = props.t('passwordContainFirstName');
  }

  if (values.password.toLowerCase().includes(props.userProfile.familyName.toLowerCase())) {
    errors.password = props.t('passwordContainLastname');
  }

  if (values.password.toLowerCase().includes(props.userProfile.userName.toLowerCase())) {
    errors.password = props.t('passwordContainUsername');
  }

  if(values.password.indexOf(".")  >= 0 ) {
    errors.password = props.t('passwordContainPeriod');
  }

  if (!values.confirm) {
    errors.confirm = props.t('confirmPasswordErr');
  } else if (values.confirm !== values.password) {
    errors.confirm = props.t('matchPassword');
  }

  return errors;
};

const PasswordResetComponent = (props) => {
  const {
    values,
    handleChange,
    dirty,
    errors,
    t,
    touched,
    isSubmitting,
    qsValue,
    getUserProfile,
    setUserProfile,
    showNotification
  } = props

  useEffect(() => {
    document.title = `City of Seattle | ${t('resetPassword')}`;

    const params = queryString.parse(qsValue);
    const _token = sessionStorage.getItem('idcsToken');
    if(_token) {
      getUserProfile(_token);
    } else if(params.userName) {
      const queryStringUsername = decodeURIComponent(window.location.href.split("userName=")[1]);
      // ATTN: This does not work because endpoint requires idcs token saved in session storage
      // checkProvisioning(encodeURIComponent(queryStringUsername))
      // .then(response => {
      //   setUserProfile({ ...response.data.Resources[0].name, userName: response.data.Resources[0].userName });
      // })
    }
  }, [t])

  const [capsLock, setCapsLock] = useState(false);
  
  const handleKeyDown = (e) => {
  const checkLock = e.getModifierState('CapsLock');
    setCapsLock(checkLock);
  }
    function getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    values.appName = getParameterByName('appName');
    values.appName = values.appName.replace(/\//g, '');
  return (
    <div>
      <h2>{t('resetPassword')}</h2>
      <Form className="App-form" onKeyDown={handleKeyDown}>
        <div className={"form-group form-group-lg password-form-group " + (errors.password && touched.password ? 'has-error' : '')}>
          <label htmlFor="password" className="control-label">{t('newPassword')} <span className="text-danger">*</span></label>
          <Field type="password" className="form-control password-field" name="password" value={values.password} maxLength="20" onChange={handleChange} />
          {capsLock && ( 
            <div className="exception-margin invalid-password" style={{marginBottom: '10px'}}>
              <span className="text-warning" role="alert">
                <span className="glyphicon glyphicon-warning-sign" aria-hidden="true"></span>
                <span className="sr-only">{t('capsLockIsOn')}</span>
              </span>
              {t('capsLockIsOn')}
            </div>
          )}
          <PasswordStrengthMeter password={values.password} />
          {errors.password && touched.password && <div className="text-danger exception-margin invalid-password" role="alert">
            <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
            <span className="sr-only">Error:</span>
            {touched.password && errors.password}
          </div>}
          <p className="password-policy">{t('passwordPolicy')}</p>
        </div>
        <div className={"form-group form-group-lg " + (errors.confirm && touched.confirm ? 'has-error' : '')}>
          <label htmlFor="confirm" className="control-label">{t('confirmNewPassword')} <span className="text-danger">*</span></label>
          <Field type="password" className="form-control" name="confirm" value={values.confirm} maxLength="20" onChange={handleChange} />
          {errors.confirm && touched.confirm && <div className="text-danger exception-margin" role="alert">
            <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
            <span className="sr-only">Error:</span>
            {touched.confirm && errors.confirm}
          </div>}
        </div>
        <button type="submit" className="btn btn-primary btn-lg btn-block" disabled={!dirty || Object.keys(errors).length !== 0 || isSubmitting}>{t('submit')}</button>
      </Form>
    </div>
  )
}

const PasswordReset = withFormik({
  mapPropsToValues({ password, confirm }) {
    return {
      password: password || '',
      confirm: confirm || '',
    }
  },
  validate: validate,
  handleSubmit: (values, { props, setSubmitting }) => {
    const { password } = values;
    const { qsValue } = props;
    const params = queryString.parse(qsValue);

      setNewPassword(password, params.token)
          .then(response => {
              if (params.userName) {
                  userStatus(params.userName.trim())
                      .then(response => {
                          if (response) {
                              // console.log("this section hit")

                              // ATTN: 'groups' property doesn't seem to currently exist (setting conditional below in case this changes)
                              if (response.data.groups) {
                                const firstLoginGroup = 'NewlyProvisioned'
                                const firstLoginGroupTest = 'KubraImport'   // temp group for QA testing
                                const groups = response.data.groups

                                const inNew = groups.includes(firstLoginGroup)
                                const inTest = groups.includes(firstLoginGroupTest)

                                // refactor after QA testing
                                if (inNew) {
                                    removeFromGroup(params.userName, firstLoginGroup)
                                }
                                if (inTest) {
                                    removeFromGroup(params.userName, firstLoginGroupTest)
                                }
                              }
                              props.showNotification({
                                  type: 'success',
                                  title: props.t('passwordResetSuccessTitle'),
                                  message: `${props.t('passwordResetSuccess')} You will be redirected in a moment`
                              });
                              resetPasswordConfirmation(params.userName.trim(), values.appName).then(() => {
                                  resetUserEmail(params.userName.trim()).then(() => {
                                      var redirectUrl;
                                      appUrls(values.appName).then((response) => {
                                          redirectUrl = response.data.loginUrl;                   
                                      });  
                                      setTimeout(() => { window.location.href = redirectUrl; }, 3000);
                                  });                             
                              });
                          }
                      });
              }
          })
      .catch(error => {
        let message = (error.response && error.response.data && error.response.data.detail) ? error.response.data.detail : props.t('registrationFailed');

        if (message.includes('The password does not meet the criteria of the password policy because:')) {
          let index = 0;
          let newMessage = 'The password does not meet the criteria of the password policy because: The password cannot contain ';
  
          if (message.includes('First Name of the user')) {
            newMessage += GetConjuctionWord(index);
            newMessage += 'First Name';
            index++;
          }
  
          if (message.includes('Last Name of the user')) {
            newMessage += GetConjuctionWord(index);
            newMessage += 'Last Name';
            index++;
          }
  
          if (message.includes('user name')) {
            newMessage += GetConjuctionWord(index);
            newMessage += 'userName';
            index++;
          }
  
          message = newMessage + '.';

          props.showNotification({
            type: 'failure',
            title: props.t('registrationFailedTitle'),
            message: message.replace('User Name', 'userName')
          });
        } else {
          const forgotPasswordUrl = window.location.origin + '/#/forgot-password';

          props.showNotification({
            type: 'failure',
            title: props.t('passwordResetFailedTitle'),
            message: props.t('passwordResetFailed'),
            link: forgotPasswordUrl,
            linkText: props.t('passwordResetFailedLinkText')
          });
        }
  
        function GetConjuctionWord(index) {
          let ret = "";
          switch (index) {
            case 0:
              ret = 'the ';
              break;
            case 1:
              ret = ', ';
              break;
            case 2:
              ret = ' or ';
              break;
            default:
              ret = 'the ';
              break;
          }
  
          return ret;
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  }
})(PasswordResetComponent)

export default withTranslation()(PasswordReset);
